import store from '@/store';
// import headerH5 from '@/components/h5/common/headerH5.vue'
import headerV2H5 from '@/components/h5/common/headerV2H5.vue';
import tabbarH5 from '@/components/h5/common/tabbarH5.vue'
// import assistiveToolH5 from '@/components/h5/common/assistiveToolH5.vue'
import { promoteUrl } from "@/utils/url";
import othersViewH5 from "@/views/h5/others/OthresViewH5.vue";

/**
 * @description
 * * components 说明:
 * - 在 components: { [key]: ... } 的配置，会在对应的 <router-view name="[key]"> 里呈现
 * - 页面主要内容: default
 * - 可全局加载的共用元件: 依照页面情境选择性添加，好比 header, footer, sidebar...
 * * components 对应画面处理说明:
 * - 在 layoutH5 里处理上述 components 元件在画面上放置的位置
 */
const routesH5 = [
  {
    path: '/',
    name: 'home',
    components: {
      headerH5: headerV2H5,
      default: () => import('@/views/h5/home/HomeViewV2H5.vue'),
      tabbarH5,
      // assistiveToolH5,
    },
    meta: {
      title: '抖圈 - 为du而生',
      keepAlive: false // 關閉
    }
  },
  {
    path: '/signpopup',
    name: 'signpopup',
    components: {
      default: () => import('@/components/h5/popup/SignPopupH5'),
    },
    meta: {
      title: '簽到',
      keepAlive: true
    }
  },
  {
    path: '/user/:userId?',
    name: 'user',
    components: {
      default: () => import('@/views/h5/user/UserViewH5')
    },
    meta: {
      title: '主页 - 抖圈 - 为du而生',
      keepAlive: false
      // true 的话会报错
      // ---> Uncaught (in promise) TypeError: parentComponent.ctx.deactivate is not a function
    },
    children: [
      {
        // * 主页
        path: "",
        name: 'space',
        alias: ['profile'],
        components: {
          // TODO: 个人主页
          my: () => import('@/views/h5/user/pages/MySpaceViewH5')
          // X other
        },
        beforeEnter: (to, from) => {
          const myUserId = store.getters['user/userId']
          const paramUserId = to.params?.userId || store.getters['user/userId']
          const isMine = myUserId === paramUserId
          if (isMine) {
            // 转业到旧的个人主页
            // store.dispatch("common/handleLoading", true)
            // store.dispatch("common/closeRedirectLoadingInterval")
            // location.href = promoteUrl() + '/home.php?mod=space&do=profile&mycenter=1&mobile=2'
            // return false
            to.params = { userId: store.getters['user/userId'] }
          } else {
            // 他人空间无主画面，导页至 [ 帖子 ]
            return {
              name: 'thread',
              query: to.query,
              params: to.params
            }
          }
        },
      },
      {
        // * 帖子
        path: 'thread/:type?',
        //  - 发布 type = ''
        //  - 回复 type = 'reply'
        //  - 打赏 type = 'donate' (新增)
        //  - 收藏 type = 'favorite' (新增)
        name: 'thread',
        components: {
          my: () => import('@/views/h5/user/pages/MyThreadViewH5'),
          other: () => import('@/views/h5/user/pages/UserThreadViewH5'),
        }
      },
      {
        // * 消息
        path: 'notice/:type?',
        //  - 系統消息 type = ''
        //  - 私人消息 type = 'personal'
        name: 'notice',
        meta: {
          requiresAuth: true,
          auth: {
            isMeOnly: true
          }
        },
        components: {
          my: () => import('@/views/h5/user/pages/MyNoticeViewH5')
          // X other
        }
      },
      {
        // * 草稿
        path: 'draft',
        name: 'draft',
        meta: {
          requiresAuth: true,
          auth: {
            isMeOnly: true
          }
        },
        components: {
          my: () => import('@/views/h5/user/pages/MyDraftViewH5')
          // X other
        }
      },
      {
        path: 'follower',
        name: 'follower',
        components: {
          my: () => import('@/views/h5/user/pages/MyfollowerViewH5'),
          other: () => import('@/views/h5/user/pages/UserfollowerViewH5'),
        }
      },
      {
        // 关注
        path: 'follow/:type?',
        //  - 用户 type = ''
        //  - 话题 type = 'topic'
        name: 'follow',
        meta: {
        },
        components: {
          my: () => import('@/views/h5/user/pages/MyFollowViewH5'),
          other: () => import('@/views/h5/user/pages/UserfollowViewH5'),
        }
      },
      {
        path: 'settings',
        name: 'settings',
        meta: {
          requiresAuth: true,
          auth: {
            isMeOnly: true
          },
          keepAlive: true
        },
        components: {
          my: () => import('@/views/h5/user/pages/MySettingsViewH5'),
        }
      },
      {
        path: 'bill/:type?',
        name: 'bill',
        meta: {
          requiresAuth: true
        },
        components: {
          my: () => import('@/views/h5/user/pages/MyBillViewH5'),
          // other: () => import('@/views/h5/user/pages/UserfollowerViewH5'),
        }
      },
    ]
  },
  {
    // 话题
    path: '/topic/:id/:type?/:page?',
    //  - 最热 type = '' || 'hot'
    //  - 最新 type = 'new'
    name: 'topic',
    meta: {
      keepAlive: false
    },
    components: {
      default:()=> import('@/views/h5/topic/TopicViewH5.vue')
    },
    beforeEnter: (to) => {
      const types = [ 'hot', 'new' ]
      const type = to.params?.type?.split('&', 1)[0]
      if (types.indexOf(type) > -1 || type === '') {
        if (+to.params?.page === 1 || !to.params?.page) return true
        else return { name: 'topic', params: { id: to.params?.id, type: type  }} // 错误的 page
      }
      else if (to.params?.id) return { name: 'topic', params: { id: to.params.id, type: types[0] }} // 错误的 type
      else return { name: 'home' }
    }
  },
  { //老哥故事. 老姐故事. 官方
    path:'/forum/:fid/:type?',
    name:'forum',
    meta:{},
    components:{
      default:()=> import('@/views/h5/forum/ForumViewH5.vue')
    }
  },
  {
    //更多關注
    path: '/recommendFollow',
    name: 'recommendFollow',
    meta:{
    },
    components: {
      default: ()=> import('@/views/h5/user/pages/followRecommendH5.vue')
    }
  },
  {
    // 排行榜
    path: '/ranking',
    name: 'ranking',
    meta: {
      title: '排行榜',
      keepAlive: false,
      tabbarKey: 'ranking'
    },
    components: {
      default:() => import('@/views/h5/ranking/RankingViewH5.vue'),
      tabbarH5,
    },
    children: [
      {
        path: "topic",
        name: 'ranking-topic',
        meta: {
          title: '话题榜',
          tabbarKey: 'ranking'
        },
        component: () => import('@/views/h5/ranking/pages/TopicRankingViewH5.vue'),
      },
      {
        path: "betking/:switch?",
        name: 'ranking-betking',
        meta: {
          title: '英雄榜',
          tabbarKey: 'ranking'
        },
        component: () => import('@/views/h5/ranking/pages/BetkingRankingViewH5.vue'),
      },
      {
        path: "fomi",
        name: 'ranking-fomi',
        meta: {
          title: '福米榜',
          tabbarKey: 'ranking'
        },
        // TODO: 改成 vue
        // component: () => import('@/views/h5/ranking/pages/FomiRankingViewH5.vue'),
        beforeEnter: (to) => {
          store.dispatch("common/handleLoading", true)
          store.dispatch("common/closeRedirectLoadingInterval")
          window.location.replace( promoteUrl() + '/ranking.php?mod=fomi')
        }
      },
      {
        path: "", // /ranking
        redirect: '/ranking/topic'
      },
    ],
  },
  {
    path: '/createTopic',
    name: 'createTopic',
    components: {
      default: () => import('@/views/h5/topic/CreateTopicViewH5'),
    },
    meta: {
      title: '创建话题',
      keepAlive: true,
      requiresAuth: true,
      auth: {
        isAdmin: true
      }
    },
  },
  {
    // 其他
    path: '/others',
    components:{
      default: othersViewH5,
    },
    children:[
      {
        path:'rule',
        name:'rule',
        meta:{
          name: '社区规则',
          title: '社区规则 - 为du而生',
          keepAlive: false
        },
        component:()=> import('@/views/h5/others/pages/RuleH5.vue'),
      },
      {
        path:'privacy',
        name:'privacy',
        meta:{
          name: '隐私说明',
          title: '隐私说明 - 为du而生',
          keepAlive: false
        },
        component:()=> import('@/views/h5/others/pages/PrivacyH5.vue'),
      },
      {
        path:'aboutus',
        name:'aboutus',
        meta:{
          name: '关于我们',
          title: '关于我们 - 为du而生',
          keepAlive: false
        },
        component:()=> import('@/views/h5/others/pages/AboutUsH5.vue'),
      },
      {
        path:'appdownload',
        name:'appdownload',
        meta:{
          name: 'APP下载',
          title: 'APP下载 - 为du而生',
          keepAlive: false
        },
        component:()=> import('@/views/h5/others/pages/AppDownloadH5.vue'),
      },
    ]
  },
  {
    // 搜索
    path: '/search/:keyword?/:type?',
    name: 'search',
    meta:{
      title: '搜索',
      keepAlive: false
    },
    components: {
      default:()=> import('@/views/h5/search/SearchViewH5.vue'),
    }
  },
  {
    // 2022年度回忆
    path: '/remember2022',
    name: 'remember2022',
    meta:{
      title: '2022年度回忆',
      keepAlive: false
    },
    components: {
      default:()=> import('@/views/h5/remember2022/RememberH5.vue'),
    },
    children: [
      {
        path: "",
        name: 'RememberIndexH5',
        meta: {
          title: '2022年度回忆',
        },
        component: () => import('@/views/h5/remember2022/pages/IndexH5.vue'),
      },
      {
        path: "detail",
        name: 'RememberDetailH5',
        meta: {
          title: '2022年度回忆',
        },
        component: () => import('@/views/h5/remember2022/pages/DetailH5.vue'),
      },
    ]
  },
  /**
   * 錯誤頁面
   */
  {
    path: '/:catchAll(.*)',
    name: 'Error404',
    components: {
      default:()=> import('@/views/h5/errors/Error404H5')
    }
  },
]

routesH5.forEach((el) => {
  if(!el.meta) el.meta = {}
  el.meta.layout = 'layoutH5'
})

export default routesH5
